export type DashboardWeekState = 'done' | 'today' | 'active' | 'abandoned' | 'unlogged' | 'future' | 'rest'

export function dashboardWeekState(
  workoutStatus: string | null,
  planned: boolean,
  isToday: boolean,
  isPast: boolean,
): DashboardWeekState {
  if (workoutStatus === 'Completed') return 'done'
  if (workoutStatus === 'InProgress') return 'active'
  if (workoutStatus === 'Abandoned') return 'abandoned'
  if (isToday && planned) return 'today'
  if (planned && isPast) return 'unlogged'
  return planned ? 'future' : 'rest'
}